import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { IrisGlobalSandbox } from '../redux/global.sandbox';
import { inject } from '@angular/core';
import { filter, map, take } from 'rxjs';

export const syncSavedAppAliasGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const params = route.firstChild.paramMap;
  if (params.get('appAlias')) {
    return true;
  }
  const globalSandbox = inject(IrisGlobalSandbox);
  const savedAppAlias = globalSandbox.savedAppAlias;
  if (!savedAppAlias) {
    return true;
  }
  const router = inject(Router);
  return globalSandbox.applications$.pipe(
    filter(applications => applications.length > 0),
    take(1),
    map(() => {
      if (globalSandbox.enabledApplications().some(app => app.applicationAlias === savedAppAlias)) {
        return router.createUrlTree(['/', savedAppAlias]);
      }
      globalSandbox.saveSelectedApp(null);
      return true;
    }),
  );
};